var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-card w-full",class:{
    'p-4': !_vm.noPadding,
    'shadow': !_vm.flat,
    '--rounded': !_vm.flat,
    'bg-white text-black': !_vm.transparent && !_vm.darkMode,
    '--dark-mode': _vm.darkMode
  },staticStyle:{"height":"max-content"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }